import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import logger from '@next/core-logger';
const replaceText = (string, replaceValue, regex) => string.replace(regex, replaceValue);
const formatTextTestIds = string => {
  const regex = / /gi;
  const replaceValue = "-";
  return string.replace(regex, replaceValue).toLocaleLowerCase();
};
const REALM_HEADER = "x-next-realm";
const TERRITORY_HEADER = "x-next-territory";
const LANGUAGE_HEADER = "x-next-language";
const CORRELATION_ID_HEADER = "x-next-correlation-id";
const SITEURL_HEADER = "x-next-siteurl";
const DEV_ESI_HEADER = "test-with-local-esi";
const VIEWPORT_SIZE_HEADER = "x-next-viewport-size";
const TIME_MACHINE_DATE_HEADER = "x-next-time-machine-date";
const SEARCH_BANNER_HEADER = "x-next-banner-format";
const PERSONA_HEADER = "x-next-persona";
const QUERY_PARAMETER_TEMPLATE_OVERRIDE = "template-override";
const HEADER = "header";
const FOOTER = "footer";
const PLP = "plp";
const RTL = "rtl";
const PLP_URL_KEYWORD_SEARCH_FILTER_IDENTIFIER = "&af=";
const PLP_MERCHANDISED_URL_FILTER_IDENTIFIER = "/f/";
const getCustomHeader = (headers, customHeader) => ({
  [customHeader]: headers[customHeader]
});
const getSettingsHeaders = headers => {
  validateHeaders(headers, "getSettingsHeaders");
  return _objectSpread(_objectSpread(_objectSpread({}, headers["x-next-persona"] && {
    "x-next-persona": headers["x-next-persona"]
  }), headers["x-next-time-machine-date"] && {
    "x-next-time-machine-date": headers["x-next-time-machine-date"]
  }), {}, {
    "x-next-language": headers["x-next-language"],
    "x-next-realm": headers["x-next-realm"],
    "x-next-territory": headers["x-next-territory"],
    "x-next-correlation-id": headers["x-next-correlation-id"],
    "x-next-viewport-size": headers["x-next-viewport-size"] || "",
    "x-next-siteurl": headers["x-next-siteurl"] || "",
    "x-next-tabbed-navigation": headers["x-next-tabbed-navigation"] || "",
    "x-next-realm-entrypoint": headers["x-next-realm-entrypoint"] || "",
    "x-next-onsite-consent": headers["x-next-onsite-consent"] || ""
  }, headers["x-next-search-source"] && {
    "x-next-search-source": headers["x-next-search-source"]
  });
};
const getSettingsHeadersAsObject = headers => {
  validateHeaders(headers, "getSettingsHeadersAsObject");
  return _objectSpread({
    language: headers["x-next-language"],
    realm: headers["x-next-realm"],
    territory: headers["x-next-territory"],
    viewportSize: headers["x-next-viewport-size"] || "",
    persona: headers["x-next-persona"] || undefined,
    timeMachine: headers["x-next-time-machine-date"] || undefined,
    tabbedNavigation: headers["x-next-tabbed-navigation"] || undefined,
    realmEntrypoint: headers["x-next-realm-entrypoint"] || undefined,
    onsiteConsent: headers["x-next-onsite-consent"] || undefined
  }, headers["x-next-search-source"] && {
    searchSource: headers["x-next-search-source"]
  });
};
const getLocaleFromHeaders = headers => {
  const language = headers[LANGUAGE_HEADER];
  const territory = headers[TERRITORY_HEADER];
  if (!language || !territory) return null;
  return "".concat(language, "-").concat(territory.toUpperCase());
};
const validateHeaders = (headers, caller) => {
  if (!headers || !headers["x-next-language"] || !headers["x-next-realm"] || !headers["x-next-territory"] || !headers["x-next-correlation-id"]) throw new Error("".concat(caller, " called with no headers"));
};
function updateApiUrlSettings(res, appScope, apiUrlSettings) {
  const newSettings = _objectSpread({}, apiUrlSettings);
  const configurationKeys = {
    ["next.ecommerce.".concat(appScope, ".frontend.api.overrideRealmWith")]: "realm",
    ["next.ecommerce.".concat(appScope, ".frontend.api.overrideTerritoryNameWith")]: "territory",
    ["next.ecommerce.".concat(appScope, ".frontend.api.overrideLanguageNameWith")]: "language"
  };
  Object.entries(configurationKeys).forEach(_ref => {
    var _res$locals;
    let [configKey, apiUrlKey] = _ref;
    const configValue = res === null || res === void 0 || (_res$locals = res.locals) === null || _res$locals === void 0 || (_res$locals = _res$locals.configuration) === null || _res$locals === void 0 ? void 0 : _res$locals[configKey];
    if (configValue) {
      newSettings[apiUrlKey] = configValue;
    }
  });
  return newSettings;
}
var realms = {
  next: {
    ae: {
      en: {
        currencies: {
          id: "66"
        }
      },
      ar: {
        currencies: {
          id: "67"
        }
      }
    },
    am: {
      en: {
        currencies: {
          id: "124"
        }
      }
    },
    ar: {
      en: {
        currencies: {
          id: "107"
        }
      }
    },
    at: {
      en: {
        currencies: {
          id: "95"
        }
      },
      de: {
        currencies: {
          id: "11"
        }
      }
    },
    au: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    az: {
      en: {
        currencies: {
          id: "121"
        }
      },
      ru: {
        currencies: {
          id: ""
        }
      }
    },
    be: {
      en: {
        currencies: {
          id: "88"
        }
      },
      fr: {
        currencies: {
          id: "87"
        }
      }
    },
    bg: {
      en: {
        currencies: {
          id: "14"
        }
      },
      bg: {
        currencies: {
          id: "77"
        }
      }
    },
    bh: {
      en: {
        currencies: {
          id: "70"
        }
      },
      ar: {
        currencies: {
          id: "78"
        }
      }
    },
    br: {
      en: {
        currencies: {
          id: "106"
        }
      }
    },
    by: {
      en: {
        currencies: {
          id: "123"
        }
      },
      ru: {
        currencies: {
          id: ""
        }
      }
    },
    ca: {
      en: {
        currencies: {
          id: "15"
        }
      },
      fr: {
        currencies: {
          id: "16"
        }
      }
    },
    ch: {
      en: {
        currencies: {
          id: "60"
        }
      },
      de: {
        currencies: {
          id: "59"
        }
      }
    },
    cl: {
      en: {
        currencies: {
          id: "104"
        }
      }
    },
    cy: {
      en: {
        currencies: {
          id: "97"
        }
      },
      el: {
        currencies: {
          id: "128"
        }
      }
    },
    cz: {
      en: {
        currencies: {
          id: "19"
        }
      },
      cs: {
        currencies: {
          id: "18"
        }
      }
    },
    de: {
      en: {
        currencies: {
          id: "97"
        }
      },
      de: {
        currencies: {
          id: "3"
        }
      }
    },
    dk: {
      en: {
        currencies: {
          id: "20"
        }
      },
      da: {
        currencies: {
          id: "80"
        }
      }
    },
    ee: {
      en: {
        currencies: {
          id: "119"
        }
      },
      ru: {
        currencies: {
          id: "118"
        }
      }
    },
    eg: {
      en: {
        currencies: {
          id: "21"
        }
      },
      ar: {
        currencies: {
          id: "22"
        }
      }
    },
    es: {
      en: {
        currencies: {
          id: "91"
        }
      },
      es: {
        currencies: {
          id: "1"
        }
      }
    },
    fi: {
      en: {
        currencies: {
          id: "98"
        }
      }
    },
    fr: {
      en: {
        currencies: {
          id: "90"
        }
      },
      fr: {
        currencies: {
          id: "89"
        }
      }
    },
    gb: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    ge: {
      en: {
        currencies: {
          id: "125"
        }
      }
    },
    gi: {
      en: {
        currencies: {
          id: "99"
        }
      }
    },
    gr: {
      en: {
        currencies: {
          id: "96"
        }
      },
      el: {
        currencies: {
          id: "81"
        }
      }
    },
    hk: {
      en: {
        currencies: {
          id: ""
        }
      },
      zh: {
        currencies: {
          id: ""
        }
      }
    },
    hr: {
      en: {
        currencies: {
          id: "95"
        }
      },
      hr: {
        currencies: {
          id: "127"
        }
      }
    },
    hu: {
      en: {
        currencies: {
          id: "79"
        }
      },
      hu: {
        currencies: {
          id: "75"
        }
      }
    },
    id: {
      en: {
        currencies: {
          id: "110"
        }
      },
      id: {
        currencies: {
          id: "130"
        }
      }
    },
    ie: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    il: {
      en: {
        currencies: {
          id: "27"
        }
      },
      he: {
        currencies: {
          id: ""
        }
      }
    },
    "in": {
      en: {
        currencies: {
          id: "26"
        }
      }
    },
    is: {
      en: {
        currencies: {
          id: "101"
        }
      },
      is: {
        currencies: {
          id: "129"
        }
      }
    },
    it: {
      en: {
        currencies: {
          id: "94"
        }
      },
      it: {
        currencies: {
          id: "6"
        }
      }
    },
    jp: {
      en: {
        currencies: {
          id: "31"
        }
      },
      ja: {
        currencies: {
          id: ""
        }
      }
    },
    kr: {
      en: {
        currencies: {
          id: "73"
        }
      },
      ko: {
        currencies: {
          id: "76"
        }
      }
    },
    kw: {
      en: {
        currencies: {
          id: "35"
        }
      },
      ar: {
        currencies: {
          id: "34"
        }
      }
    },
    kz: {
      en: {
        currencies: {
          id: "33"
        }
      },
      ru: {
        currencies: {
          id: "32"
        }
      }
    },
    lb: {
      en: {
        currencies: {
          id: "102"
        }
      },
      ar: {
        currencies: {
          id: "36"
        }
      }
    },
    lt: {
      en: {
        currencies: {
          id: "117"
        }
      },
      ru: {
        currencies: {
          id: "116"
        }
      }
    },
    lu: {
      en: {
        currencies: {
          id: "93"
        }
      },
      fr: {
        currencies: {
          id: "92"
        }
      }
    },
    lv: {
      en: {
        currencies: {
          id: "115"
        }
      },
      ru: {
        currencies: {
          id: "114"
        }
      }
    },
    mt: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    mx: {
      en: {
        currencies: {
          id: "103"
        }
      }
    },
    my: {
      en: {
        currencies: {
          id: "37"
        }
      },
      ms: {
        currencies: {
          id: "82"
        }
      },
      zh: {
        currencies: {
          id: "37"
        }
      }
    },
    nl: {
      en: {
        currencies: {
          id: "86"
        }
      },
      nl: {
        currencies: {
          id: "39"
        }
      }
    },
    no: {
      en: {
        currencies: {
          id: "40"
        }
      },
      no: {
        currencies: {
          id: "40"
        }
      }
    },
    nz: {
      en: {
        currencies: {
          id: "69"
        }
      }
    },
    om: {
      en: {
        currencies: {
          id: "42"
        }
      },
      ar: {
        currencies: {
          id: "41"
        }
      }
    },
    pe: {
      en: {
        currencies: {
          id: "105"
        }
      }
    },
    ph: {
      en: {
        currencies: {
          id: "111"
        }
      }
    },
    pk: {
      en: {
        currencies: {
          id: "108"
        }
      }
    },
    pl: {
      en: {
        currencies: {
          id: "44"
        }
      },
      pl: {
        currencies: {
          id: "43"
        }
      }
    },
    pt: {
      en: {
        currencies: {
          id: "100"
        }
      },
      pt: {
        currencies: {
          id: "100"
        }
      }
    },
    qa: {
      en: {
        currencies: {
          id: "45"
        }
      },
      ar: {
        currencies: {
          id: "46"
        }
      }
    },
    ro: {
      en: {
        currencies: {
          id: "48"
        }
      },
      ro: {
        currencies: {
          id: "47"
        }
      }
    },
    rs: {
      en: {
        currencies: {
          id: "72"
        }
      },
      sr: {
        currencies: {
          id: "72"
        }
      }
    },
    ru: {
      en: {
        currencies: {
          id: "50"
        }
      },
      ru: {
        currencies: {
          id: "49"
        }
      }
    },
    sa: {
      en: {
        currencies: {
          id: "52"
        }
      },
      ar: {
        currencies: {
          id: ""
        }
      }
    },
    se: {
      en: {
        currencies: {
          id: "74"
        }
      },
      sv: {
        currencies: {
          id: "74"
        }
      }
    },
    sg: {
      en: {
        currencies: {
          id: "53"
        }
      },
      zh: {
        currencies: {
          id: "53"
        }
      }
    },
    si: {
      en: {
        currencies: {
          id: "113"
        }
      },
      sl: {
        currencies: {
          id: "56"
        }
      }
    },
    sk: {
      en: {
        currencies: {
          id: "112"
        }
      },
      sk: {
        currencies: {
          id: "55"
        }
      }
    },
    th: {
      en: {
        currencies: {
          id: "109"
        }
      }
    },
    tr: {
      en: {
        currencies: {
          id: "63"
        }
      },
      tr: {
        currencies: {
          id: "126"
        }
      }
    },
    tw: {
      en: {
        currencies: {
          id: "62"
        }
      },
      zh: {
        currencies: {
          id: "61"
        }
      }
    },
    ua: {
      en: {
        currencies: {
          id: "65"
        }
      },
      ru: {
        currencies: {
          id: "64"
        }
      }
    },
    us: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    za: {
      en: {
        currencies: {
          id: "57"
        }
      }
    }
  },
  reiss: {
    ar: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    at: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    be: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    bg: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    br: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    ca: {
      en: {
        currencies: {
          id: "15"
        }
      },
      fr: {
        currencies: {
          id: "16"
        }
      }
    },
    cy: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    cz: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    dk: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    ee: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    eg: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    fi: {
      en: {
        currencies: {
          id: "112"
        }
      },
      fi: {
        currencies: {
          id: "112"
        }
      }
    },
    gi: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    gr: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    hr: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    hu: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    il: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    "in": {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    is: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    it: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    jp: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    kr: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    kw: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    lb: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    lt: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    lu: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    lv: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    mt: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    mx: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    my: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    pk: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    pl: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    pt: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    qa: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    ro: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    se: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    sg: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    si: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    sk: {
      en: {
        currencies: {
          id: "112"
        }
      }
    },
    th: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    tr: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    tw: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    vn: {
      en: {
        currencies: {
          id: "120"
        }
      }
    },
    za: {
      en: {
        currencies: {
          id: "120"
        }
      }
    }
  },
  childsplay: {
    ae: {
      en: {
        currencies: {
          id: ""
        }
      },
      ar: {
        currencies: {
          id: ""
        }
      }
    },
    de: {
      de: {
        currencies: {
          id: ""
        }
      }
    },
    gb: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    hk: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    ie: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    il: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    jp: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    kr: {
      en: {
        currencies: {
          id: "73"
        }
      }
    },
    kw: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    qa: {
      en: {
        currencies: {
          id: ""
        }
      }
    },
    sa: {
      en: {
        currencies: {
          id: ""
        }
      },
      ar: {
        currencies: {
          id: ""
        }
      }
    },
    tw: {
      en: {
        currencies: {
          id: "62"
        }
      }
    },
    us: {
      en: {
        currencies: {
          id: ""
        }
      }
    }
  }
};
var currencies = {
  "1": {
    currencySymbol: "€",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "3": {
    currencySymbol: "€",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "4": {
    currencySymbol: "€",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "6": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "11": {
    currencySymbol: "€",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "14": {
    currencySymbol: "BGN",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "15": {
    currencySymbol: "CA$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "16": {
    currencySymbol: "CA$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "17": {
    currencySymbol: "HRK",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "18": {
    currencySymbol: "Kč",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "19": {
    currencySymbol: "Kč",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "20": {
    currencySymbol: "DKK",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "21": {
    currencySymbol: "EGP",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "22": {
    currencySymbol: "ج.م",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "26": {
    currencySymbol: "INR",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "27": {
    currencySymbol: "₪",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "31": {
    currencySymbol: "￥",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "32": {
    currencySymbol: "тг",
    spaceRequired: true,
    position: "right",
    groupSeparatorSymbol: " ",
    decimalSeparatorSymbol: ",",
    showNumOfDecimalDigits: 0
  },
  "33": {
    currencySymbol: "KZT",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ",",
    groupSeparatorSymbol: " ",
    showNumOfDecimalDigits: 0
  },
  "34": {
    currencySymbol: "د.ك",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: 3
  },
  "35": {
    currencySymbol: "KWD",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: 3
  },
  "36": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null,
    forceEnglish: true
  },
  "37": {
    currencySymbol: "MYR",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "39": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "40": {
    currencySymbol: "kr",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "41": {
    currencySymbol: "ر.ع",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "42": {
    currencySymbol: "OMR",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "43": {
    currencySymbol: "zł",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "44": {
    currencySymbol: "zł",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "45": {
    currencySymbol: "QAR",
    spaceRequired: true,
    position: "right"
  },
  "46": {
    currencySymbol: "ر.ق",
    spaceRequired: false,
    position: "left"
  },
  "47": {
    currencySymbol: "LEI",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "48": {
    currencySymbol: "LEI",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "49": {
    currencySymbol: "руб",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: " ",
    showNumOfDecimalDigits: 0
  },
  "50": {
    currencySymbol: "руб",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: 0
  },
  "52": {
    currencySymbol: "SAR",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: 0
  },
  "53": {
    currencySymbol: "SGD",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "55": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ","
  },
  "56": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "57": {
    currencySymbol: "R",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "59": {
    currencySymbol: "CHF",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: ",",
    groupSeparatorSymbol: ".",
    showNumOfDecimalDigits: null
  },
  "60": {
    currencySymbol: "CHF",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "61": {
    currencySymbol: "NT$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "62": {
    currencySymbol: "NT$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "63": {
    currencySymbol: "TRY",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: ",",
    groupSeparatorSymbol: ".",
    showNumOfDecimalDigits: null
  },
  "64": {
    currencySymbol: "грн",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: " ",
    showNumOfDecimalDigits: 0,
    forceEnglish: true
  },
  "65": {
    currencySymbol: "UAH",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: 0
  },
  "66": {
    currencySymbol: "AED",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "67": {
    currencySymbol: "د.إ",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "69": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "70": {
    currencySymbol: "BD",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "72": {
    currencySymbol: "RSD",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "73": {
    currencySymbol: "KRW",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "74": {
    currencySymbol: "kr",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: " ",
    showNumOfDecimalDigits: null
  },
  "75": {
    currencySymbol: "Ft",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "76": {
    currencySymbol: "KRW",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "77": {
    currencySymbol: "BGN",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "78": {
    currencySymbol: "د.ب",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "79": {
    currencySymbol: "Ft",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "80": {
    currencySymbol: "DKK",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "81": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "82": {
    currencySymbol: "MYR",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: 2
  },
  "86": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "87": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ","
  },
  "88": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ","
  },
  "89": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "right",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "90": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "91": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "92": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "93": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "94": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "95": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "96": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "97": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "98": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "99": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "100": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "101": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "102": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "103": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "104": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "105": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "106": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "107": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "108": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "109": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "110": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "111": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "112": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ","
  },
  "113": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "114": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "115": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "116": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "117": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "118": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "119": {
    currencySymbol: "€",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "120": {
    currencySymbol: "US$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "121": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "123": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "124": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: null,
    groupSeparatorSymbol: null,
    showNumOfDecimalDigits: null
  },
  "125": {
    currencySymbol: "$",
    spaceRequired: false,
    position: "left",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "126": {
    currencySymbol: "₺",
    spaceRequired: true,
    position: "left",
    decimalSeparatorSymbol: ",",
    groupSeparatorSymbol: ".",
    showNumOfDecimalDigits: null
  },
  "127": {
    currencySymbol: "€",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "128": {
    currencySymbol: "€",
    spaceRequired: true,
    position: "right",
    decimalSeparatorSymbol: ".",
    groupSeparatorSymbol: ",",
    showNumOfDecimalDigits: null
  },
  "129": {
    currencySymbol: "ISK",
    decimalSeparatorSymbol: "",
    groupSeparatorSymbol: ",",
    position: "right",
    showNumOfDecimalDigits: 0,
    spaceRequired: true,
    textDirection: "ltr"
  },
  "130": {
    currencySymbol: "IDR",
    decimalSeparatorSymbol: "",
    groupSeparatorSymbol: ",",
    position: "left",
    showNumOfDecimalDigits: 0,
    spaceRequired: true,
    textDirection: "ltr"
  }
};
var config = {
  realms: realms,
  currencies: currencies
};
const LEFT_ALIGN = "left";
const RIGHT_ALIGN = "right";
const DEFAULT_MIN_DIGITS = 2;
const TYPE_CURRENCY = "currency";
const TYPE_LITERAL = "literal";
const TYPE_GROUP = "group";
const TYPE_DECIMAL = "decimal";
if (typeof Intl !== "object") {
  const expectedValue = "node_modules/full-icu";
  if (!process.env.NODE_ICU_DATA || process.env.NODE_ICU_DATA !== expectedValue) {
    throw new Error("NODE_ICU_DATA environment variable is not set, or not set to the correct value of ".concat(expectedValue));
  }
  const err = new Error("Intl is not available. Please install the full-icu module.");
  logger.error(err);
  throw err;
}
const formatPrice = (minPrice, maxPrice, currency, locale, realm) => {
  return minPrice === maxPrice ? formatNumber(minPrice, currency, locale, realm) : "".concat(formatNumber(minPrice, currency, locale, realm), " - ").concat(formatNumber(maxPrice, currency, locale, realm));
};
const getCurrencyConfig = (realm, locale) => {
  var _config$realms$realm;
  const splitLocale = locale === null || locale === void 0 ? void 0 : locale.toLocaleLowerCase().split("-");
  const territory = splitLocale[1];
  const language = splitLocale[0];
  const getId = (_config$realms$realm = config.realms[realm]) === null || _config$realms$realm === void 0 || (_config$realms$realm = _config$realms$realm[territory]) === null || _config$realms$realm === void 0 || (_config$realms$realm = _config$realms$realm[language]) === null || _config$realms$realm === void 0 || (_config$realms$realm = _config$realms$realm.currencies) === null || _config$realms$realm === void 0 ? void 0 : _config$realms$realm.id;
  return config.currencies[getId];
};
const getConfiguredCurrency = (price, locale, configuredCurrency) => {
  const {
    currencySymbol,
    spaceRequired,
    position,
    showNumOfDecimalDigits,
    decimalSeparatorSymbol,
    groupSeparatorSymbol,
    forceEnglish
  } = configuredCurrency;
  let formattedPrice;
  const requiredSpacing = spaceRequired ? " " : "";
  if (forceEnglish) {
    const localeParts = locale.split("-");
    locale = "en-".concat(localeParts[1]);
  }
  const numberFormatOptions = {
    style: "decimal",
    minimumFractionDigits: showNumOfDecimalDigits !== null && showNumOfDecimalDigits !== void 0 ? showNumOfDecimalDigits : DEFAULT_MIN_DIGITS,
    useGrouping: true
  };
  if (price % 1 === 0) {
    numberFormatOptions.minimumFractionDigits = 0;
    numberFormatOptions.maximumFractionDigits = 0;
  }
  const configPrice = new Intl.NumberFormat(locale, numberFormatOptions);
  if (configPrice.resolvedOptions().numberingSystem === "latn") {
    let displayedPrice = configPrice.format(price);
    if (groupSeparatorSymbol || decimalSeparatorSymbol) {
      displayedPrice = configPrice.formatToParts(price).map(_ref2 => {
        let {
          type,
          value
        } = _ref2;
        if (groupSeparatorSymbol && type === TYPE_GROUP) {
          value = groupSeparatorSymbol;
        }
        if (decimalSeparatorSymbol && type === TYPE_DECIMAL) {
          value = decimalSeparatorSymbol;
        }
        return value;
      }).reduce((string, part) => "".concat(string).concat(part));
    }
    switch (position) {
      case LEFT_ALIGN:
        formattedPrice = "".concat(currencySymbol).concat(requiredSpacing).concat(displayedPrice);
        break;
      case RIGHT_ALIGN:
        formattedPrice = "".concat(displayedPrice).concat(requiredSpacing).concat(currencySymbol);
        break;
      default:
        formattedPrice = "".concat(currencySymbol).concat(requiredSpacing).concat(displayedPrice);
        break;
    }
  } else {
    const latinCharacterNumberFormat = new Intl.NumberFormat("".concat(locale, "-u-nu-latn"), numberFormatOptions).formatToParts(price);
    const numberOnlyLatinCharacterPrice = latinCharacterNumberFormat.map(part => {
      if (part.type !== TYPE_CURRENCY && part.type !== TYPE_LITERAL) return part.value;
      return "";
    }).join("");
    switch (position) {
      case LEFT_ALIGN:
        formattedPrice = "".concat(currencySymbol).concat(requiredSpacing).concat(numberOnlyLatinCharacterPrice);
        break;
      case RIGHT_ALIGN:
        formattedPrice = "".concat(numberOnlyLatinCharacterPrice).concat(requiredSpacing).concat(currencySymbol);
        break;
      default:
        formattedPrice = "".concat(currencySymbol).concat(requiredSpacing).concat(numberOnlyLatinCharacterPrice);
        break;
    }
  }
  return formattedPrice;
};
const getCurrency = (price, currency, locale) => {
  const numberFormatOptions = {
    style: TYPE_CURRENCY,
    currency
  };
  if (price % 1 === 0) {
    numberFormatOptions.minimumFractionDigits = 0;
    numberFormatOptions.maximumFractionDigits = 0;
  }
  const localeNumberFormat = new Intl.NumberFormat("".concat(locale), numberFormatOptions);
  if (localeNumberFormat.resolvedOptions().numberingSystem === "latn") return localeNumberFormat.format(price);
  const latinCharacterNumberFormat = new Intl.NumberFormat("".concat(locale, "-u-nu-latn"), numberFormatOptions);
  if (typeof latinCharacterNumberFormat.formatToParts !== "function") return latinCharacterNumberFormat.format(price);
  const latinCharacterNumber = latinCharacterNumberFormat.formatToParts(price);
  const numberOnlyLatinCharacterPrice = latinCharacterNumber.map(part => {
    if (part.type !== TYPE_CURRENCY && part.type !== TYPE_LITERAL) return part.value;
    return "";
  }).join("");
  const currencyPattern = new Intl.NumberFormat(locale, {
    style: TYPE_CURRENCY,
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).formatToParts(1);
  let formattedPrice = "";
  currencyPattern.forEach(part => {
    if (part.type === TYPE_CURRENCY) {
      if (part.value.endsWith(".")) {
        formattedPrice += part.value.substring(0, part.value.length - 1);
      } else {
        formattedPrice += part.value;
      }
    } else if (part.type === "literal") {
      formattedPrice += part.value;
    } else {
      formattedPrice += numberOnlyLatinCharacterPrice;
    }
  });
  return formattedPrice;
};
const getCurrencySymbol = (locale, realm, currencyCode) => {
  let currencySymbol;
  const configuredCurrency = getCurrencyConfig(realm, locale);
  if (configuredCurrency) {
    currencySymbol = configuredCurrency.currencySymbol;
    return currencySymbol;
  }
  currencySymbol = new Intl.NumberFormat(locale, {
    style: TYPE_CURRENCY,
    currency: currencyCode
  }).formatToParts(1).find(x => x.type === TYPE_CURRENCY).value;
  return currencySymbol;
};
const formatNumber = (price, currency, locale, realm) => {
  const configuredCurrency = getCurrencyConfig(realm, locale);
  if (configuredCurrency) return getConfiguredCurrency(price, locale, configuredCurrency);
  return getCurrency(price, currency, locale);
};
const getConsentCookie = request => {
  const cookie = {
    version: "0",
    consentBoxHasClosed: false,
    groups: []
  };
  const CONSENT_COOKIE_NAME = "OptanonConsent";
  const CONSENT_BOX_CLOSED_COOKIE_NAME = "OptanonAlertBoxClosed";
  if (!request.cookies) return cookie;
  if (request.cookies[CONSENT_COOKIE_NAME]) {
    const cookieParts = request.cookies[CONSENT_COOKIE_NAME].split("&");
    const consentClosedCookie = request.cookies[CONSENT_BOX_CLOSED_COOKIE_NAME];
    if (consentClosedCookie) {
      cookie.consentBoxHasClosed = true;
    }
    const cookieVersion = cookieParts.find(part => part.includes("version="));
    if (cookieVersion) {
      cookie.version = cookieVersion === null || cookieVersion === void 0 ? void 0 : cookieVersion.split("=")[1];
    }
    const cookieGroupsString = cookieParts.find(part => part.includes("groups=")) || "";
    const cookieGroupsSplit = cookieGroupsString === null || cookieGroupsString === void 0 ? void 0 : cookieGroupsString.split("=");
    if (cookieGroupsSplit.length > 1) {
      const cookieGroups = cookieGroupsSplit[1].split(",");
      cookie.groups = cookieGroups.map(group => {
        const groupParts = group.split(":");
        return {
          name: groupParts[0],
          value: groupParts[1] === "1"
        };
      });
    }
  }
  return cookie;
};
const extractTemplateOverride = (searchResponse, appScope) => {
  var _searchResponse$templ;
  return (searchResponse === null || searchResponse === void 0 || (_searchResponse$templ = searchResponse.templateOverride) === null || _searchResponse$templ === void 0 ? void 0 : _searchResponse$templ["".concat(appScope, "TemplateName")]) || "";
};
const extractTemplateName = function (validTemplates, featureSettingTemplate) {
  let templateOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  if (validTemplates[templateOverride]) return templateOverride;
  return featureSettingTemplate;
};
const Position = ["left", "right"];
const TextDirection = ["ltr", "rtl"];
const isValidateConfig = config => {
  if (!("currencySymbol" in config) || typeof config.currencySymbol !== "string") {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, currencySymbol: ".concat(config.currencySymbol));
    return false;
  }
  if (!("spaceRequired" in config) || typeof config.spaceRequired !== "boolean") {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, spaceRequired: ".concat(config.spaceRequired));
    return false;
  }
  if (!("position" in config) || !Position.includes(config.position)) {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, position: ".concat(config.position));
    return false;
  }
  if (!("decimalSeparatorSymbol" in config) || typeof config.decimalSeparatorSymbol !== "string") {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, decimalSeparatorSymbol: ".concat(config.decimalSeparatorSymbol));
    return false;
  }
  if (!("groupSeparatorSymbol" in config) || typeof config.groupSeparatorSymbol !== "string") {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, groupSeparatorSymbol: ".concat(config.groupSeparatorSymbol));
    return false;
  }
  if (!("showNumOfDecimalDigits" in config) || typeof config.showNumOfDecimalDigits !== "number") {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, showNumOfDecimalDigits: ".concat(config.showNumOfDecimalDigits));
    return false;
  }
  if (!("textDirection" in config) || !TextDirection.includes(config.textDirection)) {
    logger.error("Invalid Launch Darkly currency configuration, global.price-formatting.config, textDirection: ".concat(config.textDirection));
    return false;
  }
  return true;
};
const formatValue = function (price, currencyConfig) {
  let isSkipCurrencySymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const {
    currencySymbol,
    spaceRequired,
    position,
    showNumOfDecimalDigits,
    decimalSeparatorSymbol,
    groupSeparatorSymbol,
    textDirection
  } = currencyConfig;
  if (!isValidateConfig(currencyConfig)) {
    return price.toString();
  }
  const requiredSpacing = spaceRequired ? "\u00A0" : "";
  const numberOfDecimals = price % 1 === 0 ? 0 : showNumOfDecimalDigits;
  const rtlModifier = textDirection === "rtl" ? "\u200F" : "";
  const priceWithDecimals = price.toFixed(numberOfDecimals);
  const formattedPrice = priceWithDecimals.replace(".", decimalSeparatorSymbol).replaceAll(/\B(?=(\d{3})+(?!\d))/g, groupSeparatorSymbol);
  if (isSkipCurrencySymbol) {
    return formattedPrice;
  }
  const formattedPriceWithCurrency = position === "left" && textDirection === "ltr" ? "".concat(currencySymbol).concat(requiredSpacing).concat(rtlModifier).concat(formattedPrice) : "".concat(rtlModifier).concat(formattedPrice).concat(requiredSpacing).concat(currencySymbol);
  return formattedPriceWithCurrency;
};
const priceFormat = (minPrice, maxPrice, currencyConfig, text) => {
  if (Number.isNaN(minPrice) || Number.isNaN(maxPrice)) {
    return "-";
  }
  if (typeof minPrice !== "number" || typeof maxPrice !== "number") {
    return "".concat(text).concat(formatValue(0, currencyConfig));
  }
  try {
    return minPrice === maxPrice ? "".concat(text).concat(formatValue(minPrice, currencyConfig)) : "".concat(text).concat(formatValue(minPrice, currencyConfig), " - ").concat(formatValue(maxPrice, currencyConfig));
  } catch (_unused) {
    return "";
  }
};
const addWasNowTextToPrice = (showWas, showNow, price, wasPrice, textConfig) => {
  const wasText = showWas ? "".concat(textConfig.text.was, " ") : "";
  const saleText = showNow && wasPrice ? "".concat(textConfig.text.sale, " ") : "";
  return {
    price: "".concat(saleText).concat(price),
    wasPrice: wasPrice ? "".concat(wasText).concat(wasPrice) : ""
  };
};
const applyPriceFormatter = _ref3 => {
  let {
    minPrice,
    maxPrice,
    realm,
    locale,
    currencyCode,
    globalPriceFormattingConfig
  } = _ref3;
  const {
    currencySymbol
  } = globalPriceFormattingConfig;
  try {
    if (currencySymbol) {
      return priceFormat(minPrice, maxPrice, globalPriceFormattingConfig, "");
    }
    return formatPrice(minPrice, maxPrice, currencyCode, locale, realm);
  } catch (error) {
    logger.error(error === null || error === void 0 ? void 0 : error.message, "Error in applyPriceFormatter, defaulting to formatPrice");
    return formatPrice(minPrice, maxPrice, currencyCode, locale, realm);
  }
};
var logo$1 = {
  title: "Buy {Title} Online | Logo {CountryName}",
  description: "Shop a wide range of {Title} with Logo. Choose from 1000s of products here. Order {Title} now with express delivery.",
  keywords: "logo,logo sale,logo online,logo.co.uk,logo directory,logo online shopping,logo store",
  robots: ""
};
var next$1 = {
  title: "Buy {Title} Online | Next {CountryName}",
  description: "Shop a wide range of {Title} with Next. Choose from 1000s of products here. Order {Title} now with express delivery.",
  keywords: "next,next sale,next online,next.co.uk,next directory,next online shopping,next store",
  robots: ""
};
var xhos$1 = {
  title: "Buy {Title} Online | XHOS {CountryName}",
  description: "Shop a wide range of {Title} with XHOS. Choose from 1000s of products here. Order {Title} now with express delivery.",
  keywords: "xhos,xhos sale,xhos online,xhos.co.uk,xhos directory,xhos online shopping,xhos store",
  robots: ""
};
var gap$1 = {
  title: "Buy {Title} Online | Gap {CountryName}",
  description: "Discover our collection of {Title} at gap.co.uk. Buy {Title} online today.",
  keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
  robots: ""
};
var jojomamanbebe$1 = {
  title: "Buy {Title} Online | JoJo Maman Bébé {CountryName}",
  description: "Browse {Title} at JoJo Maman Bébé {CountryName}. Delivery options & returns available. Order now!",
  keywords: "jojo maman bebe,jojo sale,jojo online,jojomamambebe.co.uk",
  robots: ""
};
var joules$1 = {
  title: "Buy {Title} Online | Joules {CountryName}",
  description: "Browse {Title} at Joules {CountryName}. Delivery options & returns available. Order now!",
  keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
  robots: ""
};
var made$1 = {
  title: "Buy {Title} Online | Made {CountryName}",
  description: "Browse {Title} at Made {CountryName}. Delivery options & returns available. Order now!",
  keywords: "made,made sale,made online,made online shopping,made store",
  robots: ""
};
var reiss$1 = {
  title: "Buy {Title} Online | Reiss {CountryName}",
  description: "Browse {Title} at Reiss {CountryName}. Delivery options & returns available. Order now!",
  keywords: "reiss,reiss sale,reiss online shopping,reiss international stores",
  robots: ""
};
var seasons$1 = {
  title: "Buy {Title} Online | Seasons {CountryName}",
  description: "Browse {Title} at Seasons {CountryName}. Delivery options & returns available. Order now!",
  keywords: "seasons,seasons sale,seasons online shopping,seasons international stores",
  robots: "noindex, nofollow"
};
var victoriassecret$1 = {
  title: "Buy {Title} Online | Victoria's Secret {CountryName}",
  description: "Browse {Title} at Victoria's Secret {CountryName}. Delivery options & returns available. Order now!",
  keywords: "victorias secret,victorias secret sale,victoria's secret online,victoria's secret online shopping,victoria's secret store",
  robots: ""
};
var fatface$1 = {
  title: "Buy {Title} Online | Fatface {CountryName}",
  description: "Browse {Title} at Fatface {CountryName}. Delivery options & returns available. Order now!",
  keywords: "fatface,fatface sale,fatface online,fatface.com,fatface online shopping",
  robots: ""
};
var lauraashley$1 = {
  title: "Buy {Title} Online | Laura Ashley {CountryName}",
  description: "Browse {Title} at Laura Ashley {CountryName}. Delivery options & returns available. Order now!",
  keywords: "laura ashley,laura ashley sale,laura ashley online,laura ashley online shopping,laura ashley store",
  robots: ""
};
var theset$1 = {
  title: "Buy {Title} Online | TheSet {CountryName}",
  description: "Browse {Title} at TheSet {CountryName}. Delivery options & returns available. Order now!",
  keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
  robots: "noindex, nofollow"
};
var seoMetadataForMerchandisedUrls = {
  logo: logo$1,
  next: next$1,
  xhos: xhos$1,
  gap: gap$1,
  jojomamanbebe: jojomamanbebe$1,
  joules: joules$1,
  made: made$1,
  reiss: reiss$1,
  seasons: seasons$1,
  victoriassecret: victoriassecret$1,
  fatface: fatface$1,
  lauraashley: lauraashley$1,
  theset: theset$1
};
var logo = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Logo UK",
        description: "Shop for {Filters} {SearchTerm} with Logo. Choose from 1000s of products. Order {SearchTerm} now with express delivery!",
        keywords: "logo,logo sale,logo online,logo.co.uk,logo directory,logo online shopping,logo store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Logo UK",
        description: "Shop a wide range of {SearchTerm} with Logo. Choose from 1000s of products here. Order {SearchTerm} now with express delivery.",
        keywords: "logo,logo sale,logo online,logo.co.uk,logo directory,logo online shopping,logo store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} from the Logo UK online shop",
        description: "Shop for {SearchTerm} in {Filters} at Logo.co.uk. Logo day delivery and free returns available. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "Logo,logo.co.uk,Logo Directory,Logo Flowers,Logo Electrics,fashion,clothes,womens,mens,childrens,home,furniture",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} from the Logo UK online shop",
        description: "Shop for {SearchTerm} at Logo.co.uk. Logo day delivery and free returns available. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "Logo,logo.co.uk,Logo Directory,Logo Flowers,Logo Electrics,fashion,clothes,womens,mens,childrens,home,furniture",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Logo {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Logo {CountryName}. Delivery options & returns available. Order now!",
        keywords: "logo,logo sale,logo online,logo directory,logo online shopping,logo store,logo direct",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Logo {CountryName}",
        description: "Browse {SearchTerm} at Logo {CountryName}. Delivery options & returns available. Order now!",
        keywords: "logo,logo sale,logo online,logo directory,logo online shopping,logo store,logo direct",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | Logo {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - Logo {CountryName}. International shipping and returns available. Buy {SearchTerm} in {Filters} now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | Logo {CountryName}",
        description: "Shop for {SearchTerm} at - Logo {CountryName}. International shipping and returns available. Buy now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var next = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Next UK",
        description: "Shop for {Filters} {SearchTerm} with Next. Choose from 1000s of products. Order {SearchTerm} now with express delivery!",
        keywords: "next,next sale,next online,next.co.uk,next directory,next online shopping,next store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Next UK",
        description: "Shop a wide range of {SearchTerm} with Next. Choose from 1000s of products here. Order {SearchTerm} now with express delivery.",
        keywords: "next,next sale,next online,next.co.uk,next directory,next online shopping,next store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} from the Next UK online shop",
        description: "Shop for {SearchTerm} in {Filters} at Next.co.uk. Next day delivery and free returns available. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "Next,next.co.uk,Next Directory,Next Flowers,Next Electrics,fashion,clothes,womens,mens,childrens,home,furniture",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} from the Next UK online shop",
        description: "Shop for {SearchTerm} at Next.co.uk. Next day delivery and free returns available. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "Next,next.co.uk,Next Directory,Next Flowers,Next Electrics,fashion,clothes,womens,mens,childrens,home,furniture",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Next {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Next {CountryName}. Delivery options & returns available. Order now!",
        keywords: "next,next sale,next online,next directory,next online shopping,next store,next direct",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Next {CountryName}",
        description: "Browse {SearchTerm} at Next {CountryName}. Delivery options & returns available. Order now!",
        keywords: "next,next sale,next online,next directory,next online shopping,next store,next direct",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | Next {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - Next {CountryName}. International shipping and returns available. Buy {SearchTerm} in {Filters} now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | Next {CountryName}",
        description: "Shop for {SearchTerm} at - Next {CountryName}. International shipping and returns available. Buy now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var xhos = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | XHOS UK",
        description: "Shop for {Filters} {SearchTerm} with XHOS. Choose from 1000s of products. Order {SearchTerm} now with express delivery!",
        keywords: "xhos,xhos sale,xhos online,xhos.co.uk,xhos directory,xhos online shopping,xhos store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | XHOS UK",
        description: "Shop a wide range of {SearchTerm} with XHOS. Choose from 1000s of products here. Order {SearchTerm} now with express delivery.",
        keywords: "xhos,xhos sale,xhos online,xhos.co.uk,xhos directory,xhos online shopping,xhos store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} from the XHOS UK online shop",
        description: "Shop for {SearchTerm} in {Filters} at XHOS.co.uk. Next day delivery and free returns available. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "XHOS,xhos.co.uk,XHOS Directory,XHOS Flowers,XHOS Electrics,fashion,clothes,womens,mens,childrens,home,furniture",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} from the XHOS UK online shop",
        description: "Shop for {SearchTerm} at XHOS.co.uk. Next day delivery and free returns available. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "XHOS,xhos.co.uk,XHOS Directory,XHOS Flowers,XHOS Electrics,fashion,clothes,womens,mens,childrens,home,furniture",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | XHOS {CountryName}",
        description: "Browse {Filters} {SearchTerm} at XHOS {CountryName}. Delivery options & returns available. Order now!",
        keywords: "xhos,xhos sale,xhos online,xhos directory,xhos online shopping,xhos store,xhos direct",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | XHOS {CountryName}",
        description: "Browse {SearchTerm} at XHOS {CountryName}. Delivery options & returns available. Order now!",
        keywords: "xhos,xhos sale,xhos online,xhos directory,xhos online shopping,xhos store,xhos direct",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | XHOS {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - XHOS {CountryName}. International shipping and returns available. Buy {SearchTerm} in {Filters} now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | XHOS {CountryName}",
        description: "Shop for {SearchTerm} at - XHOS {CountryName}. International shipping and returns available. Buy now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var gap = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Gap® UK",
        description: "Discover our collection of {Filters} {SearchTerm} at gap.co.uk. Buy {Filters} {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Gap® UK",
        description: "Discover our collection of {SearchTerm} at gap.co.uk. Buy {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} Online | Gap® UK",
        description: "Discover our collection of {Filters} {SearchTerm} at gap.co.uk. Buy {Filters} {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: "NOINDEX,FOLLOW"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Gap® UK",
        description: "Discover our collection of {SearchTerm} at gap.co.uk. Buy {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: "NOINDEX,NOFOLLOW"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm}  | Gap® UK",
        description: "Discover our collection of {Filters} {SearchTerm} at gap.co.uk. Buy {Filters} {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Gap® UK",
        description: "Discover our collection of {SearchTerm} at gap.co.uk. Buy {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm}  | Gap® UK",
        description: "Discover our collection of {Filters} {SearchTerm} at gap.co.uk. Buy {Filters} {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: "NOINDEX,FOLLOW",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Gap® UK",
        description: "Discover our collection of {SearchTerm} at gap.co.uk. Buy {SearchTerm} online today.",
        keywords: "GAP, Fashion, Clothing, Accessories, Footwear, Womenswear, Menswear, Childrenswear",
        robots: "NOINDEX, NOFOLLOW",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var jojomamanbebe = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | JoJo Maman Bébé",
        description: "Shop for {Filters} {SearchTerm} with JoJo Maman Bébé. Choose from 1000s of products. Order {SearchTerm} now with express delivery!",
        keywords: "jojo maman bebe,jojo maman bebe sale,jojo maman bebe online,jojomamanbebe.co.uk,jojo maman bebe directory,jojo maman bebe online shopping,jojo maman bebe store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | JoJo Maman Bébé",
        description: "Shop a wide range of {SearchTerm} with JoJo Maman Bébé. Choose from 1000s of products here. Order {SearchTerm} now with express delivery.",
        keywords: "jojo maman bebe,jojo maman bebe sale,jojo maman bebe online,jojomamanbebe.co.uk,jojo maman bebe directory,jojo maman bebe online shopping,jojo maman bebe store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} Online | JoJo Maman Bébé",
        description: "Shop for {SearchTerm} in {Filters} at jojomamanbebe.co.uk. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "Jojo Maman Bebe,jojomamanbebe.co.uk,Jojo Maman Bebe Directory,Jojo Maman Bebe,fashion,clothes,womens,childrens",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | JoJo Maman Bébé",
        description: "Shop for {SearchTerm} at jojomamanbebe.co.uk. 1000s of products online. Buy {SearchTerm} now!",
        keywords: "jojo maman bebe,jojomamanbebe.co.uk,jojo maman bebe Directory,Jojo Maman Bebe,fashion,clothes,womens,childrens",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | JoJo Maman Bébé {CountryName}",
        description: "Browse {Filters} {SearchTerm} at JoJo Maman Bébé {CountryName}. Delivery options & returns available. Order now!",
        keywords: "jojo maman bebe,jojo maman bebe online,jojo maman bebe directory,jojo maman bebe online shopping,jojo maman bebe store",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | JoJo Maman Bébé {CountryName}",
        description: "Browse {SearchTerm} at JoJo Maman Bébé {CountryName}. Delivery options & returns available. Order now!",
        keywords: "jojo maman bebe,jojo maman bebe online,jojo maman bebe directory,jojo maman bebe online shopping,jojo maman bebe store",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} | JoJo Maman Bébé {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - JoJo Maman Bébé {CountryName}. International shipping and returns available. Buy {SearchTerm} in {Filters} now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | JoJo Maman Bébé {CountryName}",
        description: "Shop for {SearchTerm} at - JoJo Maman Bébé {CountryName}. International shipping and returns available. Buy now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var joules = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Joules UK",
        description: "Shop {Filters} {SearchTerm} at Joules. Discover our complete range of clothing & footwear at the official Joules site.",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Joules UK",
        description: "Shop {SearchTerm} at Joules. Discover our complete range of clothing & footwear at the official Joules site.",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} Online | Joules UK",
        description: "Shop {Filters} {SearchTerm} at Joules. Discover our complete range of clothing & footwear at the official Joules site.",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Joules UK",
        description: "Shop {SearchTerm} at Joules. Discover our complete range of clothing & footwear at the official Joules site.",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Joules {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Joules {CountryName}. Delivery options & returns available. Order now!",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Joules {CountryName}",
        description: "Browse {SearchTerm} at Joules {CountryName}. Delivery options & returns available. Order now!",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | Joules {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - Joules {CountryName}. Delivery options & returns available. Order now!",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | Joules {CountryName}",
        description: "Shop for {SearchTerm} at - Joules {CountryName}. Delivery options & returns available. Order now!",
        keywords: "joules,joules sale,joules online,joules.co.uk,joules online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var made = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Made UK",
        description: "Shop {Filters} {SearchTerm} at Made. Stylish and unique pieces to upgrade your home. Visit our website now.",
        keywords: "made,made sale,made online,made.co.uk,made online shopping",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Made UK",
        description: "Shop {SearchTerm} at Made. Stylish and unique pieces to upgrade your home. Visit our website now.",
        keywords: "made,made sale,made online,made.co.uk,made online shopping",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} Online | Made UK",
        description: "Shop {Filters} {SearchTerm} at Made. Stylish and unique pieces to upgrade your home. Visit our website now.",
        keywords: "made,made.co.uk,sofas & chairs,living room,dining room,bedroom,lighting,garden",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Made UK",
        description: "Shop {SearchTerm} at Made. Stylish and unique pieces to upgrade your home. Visit our website now.",
        keywords: "made,made.co.uk,sofas & chairs,living room,dining room,bedroom,lighting,garden",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Made {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Made {CountryName}. Delivery options & returns available. Order now!",
        keywords: "made,made sale,made online,made online shopping,made store",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Made {CountryName}",
        description: "Browse {SearchTerm} at Made {CountryName}. Delivery options & returns available. Order now!",
        keywords: "made,made sale,made online,made online shopping,made store",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | Made {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - Made {CountryName}. International shipping and returns available. Buy {SearchTerm} in {Filters} now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | Made {CountryName}",
        description: "Shop for {SearchTerm} at - Made {CountryName}. International shipping and returns available. Buy now!",
        keywords: "",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var seasons = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Seasons UK",
        description: "Shop for {Filters} {SearchTerm} with Seasons. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "seasons,seasons sale,seasons online,seasons.co.uk,seasons online shopping,seasons store",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Seasons UK",
        description: "Shop for {SearchTerm} with Seasons. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "seasons,seasons sale,seasons online,seasons.co.uk,seasons online shopping,seasons store",
        robots: "noindex, nofollow"
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Seasons UK",
        description: "Shop for {Filters} {SearchTerm} with Seasons. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "seasons,seasons sale,seasons online,seasons.co.uk,seasons online shopping,seasons store",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Seasons UK",
        description: "Shop for {SearchTerm} with Seasons. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "seasons,seasons sale,seasons online,seasons.co.uk,seasons online shopping,seasons store",
        robots: "noindex, nofollow"
      }
    }
  }
};
var reiss = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Reiss UK",
        description: "Shop for {Filters} {SearchTerm} with Reiss. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "reiss,reiss sale,reiss online,reiss.co.uk,reiss online shopping,reiss store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Reiss UK",
        description: "Shop for {SearchTerm} with Reiss. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "reiss,reiss sale,reiss online,reiss.co.uk,reiss online shopping,reiss store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Reiss UK",
        description: "Shop for {Filters} {SearchTerm} with Reiss. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "reiss,reiss sale,reiss online,reiss.co.uk,reiss online shopping,reiss store",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Reiss UK",
        description: "Shop for {SearchTerm} with Reiss. Browse our wide range of designer clothing and footwear . Order {SearchTerm} with free next day delivery to store!",
        keywords: "reiss,reiss sale,reiss online,reiss.co.uk,reiss online shopping,reiss store",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Reiss {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Reiss {CountryName}. Delivery options & returns available. Order now!",
        keywords: "reiss,reiss sale,reiss online shopping,reiss international stores",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Reiss {CountryName}",
        description: "Browse {SearchTerm} at Reiss {CountryName}. Delivery options & returns available. Order now!",
        keywords: "reiss,reiss sale,reiss online shopping,reiss international stores",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Reiss {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Reiss {CountryName}. Delivery options & returns available. Order now!",
        keywords: "reiss,reiss sale,reiss online shopping,reiss international stores",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Reiss {CountryName}",
        description: "Browse {SearchTerm} at Reiss {CountryName}. Delivery options & returns available. Order now!",
        keywords: "reiss,reiss sale,reiss online shopping,reiss international stores",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var victoriassecret = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Victoria's Secret UK",
        description: "Shop for {Filters} {SearchTerm} with Victoria's Secret. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "victorias secret,victorias secret sale,victorias secret online,victoriassecret.co.uk,victorias secret online shopping,victorias secret store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Victoria's Secret UK",
        description: "Shop for {SearchTerm} with Victoria's Secret. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "victorias secret,victorias secret sale,victorias secret online,victoriassecret.co.uk,victorias secret online shopping,victorias secret store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Victoria's Secret UK",
        description: "Shop for {Filters} {SearchTerm} with Victoria's Secret. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "victorias secret,victorias secret sale,victorias secret online,victoriassecret.co.uk,victorias secret online shopping,victorias secret store",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Victoria's Secret UK",
        description: "Shop for {SearchTerm} with Victoria's Secret. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "victorias secret,victorias secret sale,victorias secret online,victoriassecret.co.uk,victorias secret online shopping,victorias secret store",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Victoria's Secret {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Victoria's Secret {CountryName}. Delivery options & returns available. Order now!",
        keywords: "victorias secret,victorias secret sale,victoria's secret online,victoria's secret online shopping,victoria's secret store",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Victoria's Secret {CountryName}",
        description: "Browse {SearchTerm} at Victoria's Secret {CountryName}. Delivery options & returns available. Order now!",
        keywords: "victorias secret,victorias secret sale,victoria's secret online,victoria's secret online shopping,victoria's secret store",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Victoria's Secret {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Victoria's Secret {CountryName}. Delivery options & returns available. Order now!",
        keywords: "victorias secret,victorias secret sale,victoria's secret online,victoria's secret online shopping,victoria's secret store",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Victoria's Secret {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Victoria's Secret {CountryName}. Delivery options & returns available. Order now!",
        keywords: "victorias secret,victorias secret sale,victoria's secret online,victoria's secret online shopping,victoria's secret store",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var fatface = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Fatface UK",
        description: "Shop {Filters} {SearchTerm} at Fatface. Discover our complete range of clothing & footwear at the official Fatface site.",
        keywords: "fatface,fatface sale,fatface online,fatface.co.uk,fatface online shopping",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | fatface UK",
        description: "Shop {SearchTerm} at Fatface. Discover our complete range of clothing & footwear at the official Fatface site.",
        keywords: "fatface,fatface sale,fatface online,fatface.com,fatface online shopping",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} Online | Fatface UK",
        description: "Shop {Filters} {SearchTerm} at Fatface. Discover our complete range of clothing & footwear at the official Fatface site.",
        keywords: "fatface,fatface sale,Fatface online,Fatface.com,fatface online shopping",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Fatface UK",
        description: "Shop {SearchTerm} at Fatface. Discover our complete range of clothing & footwear at the official Fatface site.",
        keywords: "fatface,fatface sale,Fatface online,fatface.com,Fatface online shopping",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | Fatface {CountryName}",
        description: "Browse {Filters} {SearchTerm} at Fatface {CountryName}. Delivery options & returns available. Order now!",
        keywords: "fatface,fatface sale,fatface online,fatface.com,fatface online shopping",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | Fatface {CountryName}",
        description: "Browse {SearchTerm} at Fatface {CountryName}. Delivery options & returns available. Order now!",
        keywords: "fatface,fatface sale,fatface online,fatface.com,fatface online shopping",
        robots: "",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | Fatface {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - Fatface {CountryName}. Delivery options & returns available. Order now!",
        keywords: "fatface,fatface sale,fatface online,fatface.com,fatface online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | Fatface {CountryName}",
        description: "Shop for {SearchTerm} at - Fatface {CountryName}. Delivery options & returns available. Order now!",
        keywords: "fatface,fatface sale,fatface online,fatface.com,fatface online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var lauraashley = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Laura Ashley UK",
        description: "Shop for {Filters} {SearchTerm} with Laura Ashley. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "laura ashley,laura ashley sale,laura ashley online,lauraashley.co.uk,laura ashley online shopping,laura ashley store",
        robots: ""
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Laura Ashley UK",
        description: "Shop for {SearchTerm} with Laura Ashley. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "laura ashley,laura ashley sale,laura ashley online,lauraashley.co.uk,laura ashley online shopping,laura ashley store",
        robots: ""
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | Laura Ashley UK",
        description: "Shop for {Filters} {SearchTerm} with Laura Ashley. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "laura ashley,laura ashley sale,laura ashley online,lauraashley.co.uk,laura ashley online shopping,laura ashley store",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | Laura Ashley UK",
        description: "Shop for {SearchTerm} with Laura Ashley. Choose from 1000s of products. Order {SearchTerm} with free next day delivery to store!",
        keywords: "laura ashley,laura ashley sale,laura ashley online,lauraashley.co.uk,laura ashley online shopping,laura ashley store",
        robots: "noindex, nofollow"
      }
    }
  }
};
var theset = {
  uk: {
    category: {
      withFilters: {
        title: "Buy {Filters} {SearchTerm} Online | TheSet UK",
        description: "Shop {Filters} {SearchTerm} at TheSet. Discover our complete range of clothing & footwear at the official TheSet site.",
        keywords: "theset,theset sale,theset online,theset.co.uk,theset online shopping",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | TheSet UK",
        description: "Shop {SearchTerm} at TheSet. Discover our complete range of clothing & footwear at the official TheSet site.",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow"
      }
    },
    keyword: {
      withFilters: {
        title: "Buy {SearchTerm} in {Filters} Online | TheSet UK",
        description: "Shop {Filters} {SearchTerm} at TheSet. Discover our complete range of clothing & footwear at the official TheSet site.",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow"
      },
      withoutFilters: {
        title: "Buy {SearchTerm} Online | TheSet UK",
        description: "Shop {SearchTerm} at TheSet. Discover our complete range of clothing & footwear at the official TheSet site.",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow"
      }
    }
  },
  international: {
    category: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{Filters} {SearchTerm} | TheSet {CountryName}",
        description: "Browse {Filters} {SearchTerm} at TheSet {CountryName}. Delivery options & returns available. Order now!",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} | TheSet {CountryName}",
        description: "Browse {SearchTerm} at TheSet {CountryName}. Delivery options & returns available. Order now!",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    },
    keyword: {
      withFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} in {Filters} from | TheSet {CountryName}",
        description: "Shop for {SearchTerm} in {Filters} at - TheSet {CountryName}. Delivery options & returns available. Order now!",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      },
      withoutFilters: {
        mpStart: "<!-- mp_trans_enable_start -->",
        title: "{SearchTerm} from | TheSet {CountryName}",
        description: "Shop for {SearchTerm} at - TheSet {CountryName}. Delivery options & returns available. Order now!",
        keywords: "theset,theset sale,theset online,theset.com,theset online shopping",
        robots: "noindex, nofollow",
        mpEnd: "<!-- mp_trans_enable_end -->"
      }
    }
  }
};
var seoMetadata = {
  logo: logo,
  next: next,
  xhos: xhos,
  gap: gap,
  jojomamanbebe: jojomamanbebe,
  joules: joules,
  made: made,
  seasons: seasons,
  reiss: reiss,
  victoriassecret: victoriassecret,
  fatface: fatface,
  lauraashley: lauraashley,
  theset: theset
};
const OldCategoryUrlKeys = ["benefit", "brand", "category", "department", "designfeature", "editorial", "feat", "gender", "issale", "occasion", "giftsbyoccasion", "pattern", "productaffiliation", "promotion", "size", "sizetype", "use", "collaboration", "range"];
const checkIfMerchandisedUrl = url => {
  let isMerchandisedUrl = false;
  const splitPathArray = url.split("/");
  if (url.includes("/brands") || url.includes("/promotions") || url.includes("/f/") || splitPathArray.length <= 2 && !url.includes("/search") || url.endsWith("/shop/") || url.endsWith("/shop")) {
    isMerchandisedUrl = true;
  } else if (url.includes("/shop") && splitPathArray.length > 2) {
    const index = splitPathArray.indexOf("shop");
    const searchTerm = splitPathArray[index + 1];
    const categoryStrippedQuery = searchTerm.split("?")[0].split("-");
    if (categoryStrippedQuery[categoryStrippedQuery.length - 1] === "0") {
      categoryStrippedQuery.pop();
    }
    if (categoryStrippedQuery.length % 2 === 0) {
      isMerchandisedUrl = !OldCategoryUrlKeys.includes(categoryStrippedQuery[0].toLowerCase());
    } else {
      isMerchandisedUrl = true;
    }
  }
  return isMerchandisedUrl;
};
const KEYWORD_SEARCH = "keyword";
const CATEGORY_SEARCH = "category";
const checkIfURLHasFilters = (url, searchType) => {
  if (checkIfMerchandisedUrl(url)) {
    return url.includes(PLP_MERCHANDISED_URL_FILTER_IDENTIFIER);
  }
  if (searchType === KEYWORD_SEARCH) {
    return url.includes(PLP_URL_KEYWORD_SEARCH_FILTER_IDENTIFIER);
  }
  let localURL = url;
  if (localURL.startsWith("/")) {
    localURL = localURL.slice(1);
  }
  if (localURL.endsWith("/")) {
    localURL = localURL.slice(0, localURL.length - 1);
  }
  return localURL.split("/").length > 2;
};
function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function getSeoMetadataFromConfig(_ref4) {
  var _nonMerchandisedConfi;
  let {
    url,
    realm,
    territory
  } = _ref4;
  const isMerchandisedUrl = checkIfMerchandisedUrl(url);
  const merchandisedconfig = seoMetadataForMerchandisedUrls;
  const nonMerchandisedConfig = seoMetadata;
  const searchType = url.includes("/search") ? KEYWORD_SEARCH : CATEGORY_SEARCH;
  const $withFilters = checkIfURLHasFilters(url, searchType) ? "withFilters" : "withoutFilters";
  const region = territory.toLowerCase() === "gb" ? "uk" : "international";
  const metadata = isMerchandisedUrl ? merchandisedconfig[realm] : (_nonMerchandisedConfi = nonMerchandisedConfig[realm]) === null || _nonMerchandisedConfi === void 0 || (_nonMerchandisedConfi = _nonMerchandisedConfi[region]) === null || _nonMerchandisedConfi === void 0 || (_nonMerchandisedConfi = _nonMerchandisedConfi[searchType]) === null || _nonMerchandisedConfi === void 0 ? void 0 : _nonMerchandisedConfi[$withFilters];
  if (!metadata) return null;
  return clone(metadata);
}
export { CATEGORY_SEARCH, CORRELATION_ID_HEADER, DEV_ESI_HEADER, FOOTER, HEADER, KEYWORD_SEARCH, LANGUAGE_HEADER, PERSONA_HEADER, PLP, PLP_MERCHANDISED_URL_FILTER_IDENTIFIER, PLP_URL_KEYWORD_SEARCH_FILTER_IDENTIFIER, QUERY_PARAMETER_TEMPLATE_OVERRIDE, REALM_HEADER, RTL, SEARCH_BANNER_HEADER, SITEURL_HEADER, TERRITORY_HEADER, TIME_MACHINE_DATE_HEADER, VIEWPORT_SIZE_HEADER, addWasNowTextToPrice, applyPriceFormatter, checkIfMerchandisedUrl, checkIfURLHasFilters, extractTemplateName, extractTemplateOverride, formatPrice, formatTextTestIds, formatValue, getConsentCookie, getCurrencySymbol, getCustomHeader, getLocaleFromHeaders, getSeoMetadataFromConfig, getSettingsHeaders, getSettingsHeadersAsObject, priceFormat, replaceText, seoMetadata, seoMetadataForMerchandisedUrls, updateApiUrlSettings };